import React, { Component } from 'react'
import { Link } from 'react-router'
import Modal from 'react-modal'
import Slider from 'react-slick'
import Button from 'muicss/lib/react/button'
import Container from 'muicss/lib/react/container'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'
import IcoAdd from 'react-icons/lib/io/ios-plus-outline'
import IcoAdded from 'react-icons/lib/io/ios-checkmark-outline'
import IcoClose from 'react-icons/lib/io/ios-close-outline'
import util from '../util'
import _ from 'lodash'

const sliderSettings = vimg => ({
  arrows: false,
  customPaging: function(i) {
    // TODO: 画像データと紐つけ
    return (<a>{vimg[i]}</a>)
  },
  dots: true,
  dotsClass: 'slick-dots slick-thumb',
  fade: true
})

const ItemModal = ({ item, back, query, withoutCarriage, shouldSubtractCarriage, enableScroll }) => {
  if (item) {
    enableScroll(false)
  } else {
    enableScroll(true)
  }

  const priceCaption = util.priceCaption(withoutCarriage)
  const vimg = item ? item.images.map((x,k) => (
    <img key={k} src={x} alt="" />
  )) : []

  const oid = _.get(item, 'selects_order_id')

  const variations = item && item.variations && item.variations.length > 0 ? (
    <div>
        <p>バリエーション</p>
        <ol>
            {item.variations.map((v,i) => <li key={i}>{v}{oid.length > i ? <div className="modal-item__spec">申込み番号: {oid[i]}</div> : null}</li>)}
        </ol>
    </div>
  ) : null;

  const specs = oid && ! variations ?
        [{dt: '申込番号', dd: oid}] :
        []

  return (
    <div>
        <Modal isOpen={!!item} className="modal-content" overlayClassName="modal-overlay">
            <Row>
                <Link to={back} query={query}>
                    <IcoClose className="modal-item__close-button" />
                </Link>
                <Col className="modal-item__image-container" md="6" xs="12">
                    <Slider {...sliderSettings(vimg)}>
                        {vimg}
                    </Slider>
                </Col>
                <Col className="modal-item__info-container" md="6" xs="12">
                    <h2 className="modal-item__title">{_.get(item, 'name')}</h2>
                    <h3 className="modal-item__price">{/* &yen;{util.displayPrice(_.get(item, 'price'), shouldSubtractCarriage)}<span>{priceCaption}</span> */}</h3>
                    <p className="modal-item__description">{_.get(item, 'catch_copy')}</p>
                    <dl className="modal-item__spec">
                        {specs.map((x,k) => [
                            <dt key={`dt-${k}`}>{x.dt}</dt>
                            , <dd key={`dd-${k}`}>{x.dd}</dd>
                        ])}
                    </dl>
                    {variations}
                    <p className="modal-item__remark">{_.get(item, 'annotation')}</p>
                    <div className="modal-item__action">
                        {/*
                        <Button size="large" className="modal-item__action--add"><IcoAdd />リストに追加</Button>
                        <Button size="large" color="accent" className="modal-item__action--added"><IcoAdded />リストから削除</Button>
                        */}
                    </div>
                </Col>
            </Row>
        </Modal>
    </div>
  )
}

export default ItemModal



// WEBPACK FOOTER //
// ./src/components/ItemModal.jsx